"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enableCustomConnects;
/**
 * Shims the `AudioNode.connect()` method and lets you choose
 * which audio nodes to actually connect to each other.
 *
 * @see https://github.com/Theodeus/tuna/blob/master/tuna.js#L153
 *
 * @param  {AudioContext} context        An AudioContext instance
 * @param  {Function}     inputSelector  A function that takes an object that
 *                                       has been passed to `AudioNode.connect()`
 *                                       and returns what the calling audio node
 *                                       should actually connect to
 */
function enableCustomConnects(context, inputSelector) {
  if (context.__connectified === true) {
    return;
  }

  function shimConnect(node) {
    var nodeInput = inputSelector(node);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var finalArgs = [nodeInput].concat(args);
    oconnect.apply(this, finalArgs);
    return node;
  }

  var gain = context.createGain();
  var proto = Object.getPrototypeOf(Object.getPrototypeOf(gain));
  var oconnect = proto.connect;

  proto.connect = shimConnect;
  context.__connectified__ = true;
}